import { BusEvent } from '../events/bus-event';
import { filter, Observable, Subject } from 'rxjs';
import { Constructor, isInstanceOf } from '@web/utils';

export abstract class EventBusService {
  private readonly eventSource$ = new Subject<BusEvent>();

  public publish(event: BusEvent): void {
    this.eventSource$.next(event);
  }

  public events$(): Observable<BusEvent> {
    return this.eventSource$.asObservable();
  }

  public observe<Event extends BusEvent>(
    type: Constructor<Event>,
  ): Observable<Event> {
    return this.eventSource$.pipe(
      filter((event): event is Event => isInstanceOf(event, type)),
    );
  }

  public observeMultiple<Event extends BusEvent>(
    types: Array<Constructor<Event>>,
  ): Observable<Event> {
    return this.eventSource$.pipe(
      filter((event): event is Event =>
        types.some((type) => isInstanceOf(event, type)),
      ),
    );
  }
}
